import { render, staticRenderFns } from "./SwitchText.vue?vue&type=template&id=10bdbaee&"
import script from "./SwitchText.vue?vue&type=script&lang=js&"
export * from "./SwitchText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports